import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, KeepAlive as _KeepAlive, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33818513"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "tw-py-4"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "No further configuation needed. Proceed to the Process step", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Summary", -1))

import xlsx, { WorkBook } from "xlsx";
import { storeToRefs } from "pinia";
import { UseProgramStore } from "../../../Modules/State/Stores/ProgramStore";
import { UseSegementStore } from "../../../Modules/State/Stores/SegmentStore";
import { computed, onMounted, ref, watch } from "vue";
import { UseCanvasGridHelper } from "../../../Helper/ThirdParty/UseCanvasGridHelper";
import { UseUrlBuilder } from "../../../Helper/Stateful/UseUrlBuilder";
import { UseArrayHelper } from "../../../Helper/Functional/UseArrayHelper";
import { useRouter, useRoute } from "vue-router";
import axios from "axios";
import swal from "sweetalert2";
import { chain, each, get, assign, has, every, pick } from "lodash";
import { TJsonFromSheet, UseUpload } from "./Hooks/UseUpload";


import BatchFixedFileUpload from "../../../Modules/Account/BatchCosts/ExcelAndCsvFileUpload.vue";
import BatchSegmentFieldConfiguration from "../../../Modules/SegmentManagement/UploadFileComponents/BatchSegmentFieldConfiguration.vue";
import FileUpload from "../../../Modules/SegmentManagement/UploadFileComponents/Steps/FileUpload.vue";
import FileOptions from "../../../Modules/SegmentManagement/UploadFileComponents/Steps/FileOptions.vue";
import FileConfiguration from "../../../Modules/SegmentManagement/UploadFileComponents/Steps/FileConfiguration.vue";

const __default__ = {
  title: "Segment Upload",
  components: {
    BatchFixedFileUpload,
    BatchSegmentFieldConfiguration,
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { getCurrentProgram } = storeToRefs(UseProgramStore());

const { setSegmentGroupData } = UseSegementStore();
const {
  basicSegmentPostUrlBuilder,
  basicSegmentGroupUrl,
  segmentGroup: segmentGroupForUrl,
} = UseUrlBuilder({
  dataSet: "",
});
const {
  itemInArrayFrequencyCounter,
  createArrayFromSingleNumber,
  removeFirstItemFromArray,
  removeItemFromArrayUsingIndex,
} = UseArrayHelper();
const abc = ref(null);
UseCanvasGridHelper(abc);
const {
  file,
  currentSheet,
  configuration,
  segmentGroup,
  segmentGroupData,
  uniqueId,
  showError,
  showLastStep,
  allUniqueIds,
  allSheets,
  currentToJsonRef,
  availableColumns,
  sheetSegments,
  knownSegmentNames,
  unknownSegmentNamesRef,
  firstRowContainsHeaders,
  step,
  skipRows,
  rows,
  fileDataExtractorToJson,
  setCurrentToJsonRef,
} = UseUpload();

const loading = ref(false);

onMounted(() => {
  const { params } = useRoute();
  segmentGroupForUrl.value = params.group as string;
});

const processedData = ref<{
  upload_id: string;
  orders: { order_id: string; segment: string }[];
}>();

//Store orginal json objects from the sheet. These will be used to replenish the grid when user messes about with the various toggles.
const originalJsonObjects = ref<TJsonFromSheet[]>([]);

const summary = computed(() => {
  return {
    count: sendData.value.length,
  };
});
const summaryBreakdown = computed(() => {
  const segmentOnlyArray = sendData.value.map((key) => key.segment);
  return itemInArrayFrequencyCounter(segmentOnlyArray);
});
const sendData = computed(() => {
  return chain(currentToJsonRef.value!)
    .map(function (val) {
      let rtn = {} as { order_id: string; segment: string };

      each(configuration, function (inner, innerKey) {
        if (inner.value === null) {
          return;
        }

        if (inner.type === "dynamic") {
          if (get(val, inner.value, "") === "") {
            return;
          }
          assign(rtn, { [innerKey]: get(val, inner.value) });
        } else {
          assign(rtn, { [innerKey]: inner.value });
        }
      });
      return rtn;
    })
    .filter(function (val) {
      return (
        has(val, "order_id") &&
        has(val, "segment") &&
        every(pick(val, ["segment", "order_id"]))
      );
    })
    .value();
});

const process = () => {
  processedData.value = {
    upload_id: currentSheet.value,
    orders: [...sendData.value],
  };
  loading.value = true;
  axios
    .post(basicSegmentPostUrlBuilder.value, processedData.value)
    .then(function () {
      swal
        .fire({
          type: "success",
          title: "Uploaded!",
          text: "Thank you. The data is now being processed.",
          confirmButtonText: "Close",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        .then(function (result) {
          if (result.value) {
            step.value = 0;
          }
        });

      loading.value = false;
    })
    .catch(() => {
      swal
        .fire({
          type: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: "Please check your sheet",
        })
        .then(function (result) {
          if (result.value) {
            step.value = 0;
            loading.value = false;
          }
        });
    });
};
const fetchAllGroupData = () => {
  if (!segmentGroupData.value) {
    loading.value = true;
    axios.get(basicSegmentGroupUrl.value).then(({ data }) => {
      setSegmentGroupData({ data: data.data });

      loading.value = false;
    });
  }
};

const checkForDuplicateIDs = (val = "") => {
  return allUniqueIds.value?.findIndex((group) => group.upload_id === val) !== -1;
};

const { push, replace } = useRouter();
onMounted(async () => {
  if (!segmentGroupData.value) {
    fetchAllGroupData();
    try {
      const { data } = await axios.get(basicSegmentPostUrlBuilder.value);
      allUniqueIds.value = data.data;
    } catch (e) {
      swal
        .fire({
          type: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: "There doesn't seem to be a segment group for this client.",
        })
        .then(function (result) {
          if (result.value) {
            step.value = 0;
            loading.value = false;
            replace("/segment-groups");
          }
        });
    }
  }
});

watch(sheetSegments, (val) => {
  unknownSegmentNamesRef.value = val.filter(
    (segObject) =>
      !knownSegmentNames.value
        .map((segName) => segName.segment_name)
        .includes(segObject.segmentName)
  );
});

watch(allSheets, (newVal) => {
  if (newVal === null || newVal.length === 0) {
    currentSheet.value = "";
  } else {
    if (newVal.length > 0) {
      currentSheet.value = newVal[0];
    }
  }
});

watch(segmentGroup, (val) => {
  push(`/segment-groups/upload/${val}`);
});

watch(currentSheet, (val) => {
  if (!checkForDuplicateIDs(val)) {
    showError.value = false;
    uniqueId.value = val;
    currentSheet.value = val;
  } else {
    showError.value = true;
  }
});
watch(uniqueId, (val) => {
  if (!checkForDuplicateIDs(val)) {
    showError.value = false;
    uniqueId.value = val;
  } else {
    showError.value = true;
  }
});
watch(getCurrentProgram, () => {
  setSegmentGroupData({ data: [] });
  replace("/segment-groups");
});
watch(
  [currentSheet, file],
  ([_, newFile]) => {
    xlsx.utils.encode_col(1);
    setCurrentToJsonRef(fileDataExtractorToJson(newFile as WorkBook));
    originalJsonObjects.value = currentToJsonRef.value;
    rows.value = currentToJsonRef.value.length;
  },
  { deep: true }
);

//Temp reactive vars for watchers
const tempGridItems = ref<TJsonFromSheet[]>([]);
const tempCount = ref(0);

//DRY Functions

const settingCurrentToJsonRefWithFileDataExtractor = () => {
  setCurrentToJsonRef(fileDataExtractorToJson(file.value as WorkBook));
};

const skipRowsIsNan = (val: number) => {
  //Reset temp vars
  tempGridItems.value = [];
  tempCount.value = 0;
  if (firstRowContainsHeaders.value) {
    settingCurrentToJsonRefWithFileDataExtractor();
  } else {
    currentToJsonRef.value = originalJsonObjects.value;
  }
  if (isNaN(val)) skipRows.value = 0;
};

const skipRowsNewValIsBigger = (val: number, oldVal: number) => {
  createArrayFromSingleNumber(val - oldVal).forEach(() => {
    if (currentToJsonRef.value.length) {
      tempGridItems.value[tempCount.value] = currentToJsonRef.value[0];
      setCurrentToJsonRef(removeFirstItemFromArray(currentToJsonRef.value));
      tempCount.value++;
    }
  });
};

const skipRowsNewValIsSmaller = (val: number, oldVal: number) => {
  createArrayFromSingleNumber(oldVal - val).forEach(() => {
    tempCount.value--;
    if (firstRowContainsHeaders.value) {
      settingCurrentToJsonRefWithFileDataExtractor();
    } else {
      setCurrentToJsonRef([
        tempGridItems.value[tempCount.value],
        ...currentToJsonRef.value,
      ]);
      tempGridItems.value = removeItemFromArrayUsingIndex(
        tempGridItems.value,
        tempCount.value
      );
    }
  });
};

watch(firstRowContainsHeaders, () => {
  settingCurrentToJsonRefWithFileDataExtractor();
});

watch(currentToJsonRef, () => {
  availableColumns.value = chain(currentToJsonRef.value).first().keys().value();
});

watch(skipRows, (val, oldVal) => {
  if (isNaN(val) || val === 0) {
    skipRowsIsNan(val);
    return;
  }
  //Increasing skipped rows
  if (val > oldVal) {
    skipRowsNewValIsBigger(val, oldVal);
  } else {
    skipRowsNewValIsSmaller(val, oldVal);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_canvas_datagrid = _resolveComponent("canvas-datagrid")!
  const _component_o_step_item = _resolveComponent("o-step-item")!
  const _component_o_steps = _resolveComponent("o-steps")!
  const _component_outer_section = _resolveComponent("outer-section")!

  return (_openBlock(), _createBlock(_component_outer_section, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_o_steps, {
          modelValue: _unref(step),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(step) ? (step).value = $event : null)),
          variant: "black",
          animated: false,
          "has-navigation": _unref(file) && !_unref(showError) ? true : false
        }, {
          default: _withCtx(() => [
            (_unref(file) !== null && _unref(step) > 1)
              ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                  (_openBlock(), _createBlock(_KeepAlive, null, [
                    _createVNode(_component_canvas_datagrid, {
                      ref_key: "abc",
                      ref: abc,
                      ".data": _unref(currentToJsonRef)
                    }, null, 8, [".data"])
                  ], 1024))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_o_step_item, {
              label: "File Upload",
              icon: "file-upload",
              class: "tw-p-4",
              step: "1"
            }, {
              default: _withCtx(() => [
                _createVNode(FileUpload)
              ]),
              _: 1
            }),
            _createVNode(_component_o_step_item, {
              label: "Options",
              icon: "file-question",
              step: "2"
            }, {
              default: _withCtx(() => [
                _createVNode(FileOptions)
              ]),
              _: 1
            }),
            (_unref(showLastStep))
              ? (_openBlock(), _createBlock(_component_o_step_item, {
                  key: 1,
                  label: "Configuration",
                  icon: "cog",
                  step: "3"
                }, {
                  default: _withCtx(() => [
                    (_unref(unknownSegmentNamesRef).length > 0)
                      ? (_openBlock(), _createBlock(FileConfiguration, { key: 0 }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(showLastStep))
              ? (_openBlock(), _createBlock(_component_o_step_item, {
                  key: 2,
                  label: "Process",
                  icon: "cloud-upload",
                  step: "4"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, "There are " + _toDisplayString(_unref(summary).count) + " lines to be processed:", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaryBreakdown), (amt, key) => {
                          return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(amt) + " of " + _toDisplayString(key), 1))
                        }), 128))
                      ]),
                      _createElementVNode("button", {
                        class: _normalizeClass(["button is-primary", [{ 'is-loading': loading.value }]]),
                        onClick: process
                      }, " Process ", 2)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "has-navigation"])
      ])
    ]),
    _: 1
  }))
}
}

})